import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker as DesktopDatePicker } from '@mui/x-date-pickers/DatePicker';
import { useMediaQuery, useTheme } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { fr } from 'date-fns/locale';

export type DatePickerValue = Date | null;

export type DatePickerProps = {
  onAccept?: (value: DatePickerValue) => void;
  handleChange: (date: DatePickerValue) => void;
  shouldDisableDate?: (date: Date) => boolean;
  value: Date | null;
  label?: string;
  maxDate?: Date;
  minDate?: Date;
  views?: ('year' | 'day' | 'month')[];
  openTo?: 'year' | 'day' | 'month';
  disabled?: boolean;
  onClose?: any;
  ariaLabel?: string;
  sx?: SxProps<Theme>;
};

const DatePicker = ({
  handleChange,
  onAccept,
  value,
  label = '',
  views,
  openTo,
  disabled,
  shouldDisableDate,
  onClose,
  minDate,
  maxDate,
  ariaLabel,
  ...props
}: DatePickerProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
      {isMobile ? (
        <MobileDatePicker
          aria-label={ariaLabel}
          onAccept={onAccept}
          onClose={onClose}
          disabled={disabled}
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          openTo={openTo ? openTo : 'day'}
          views={views ? views : ['year', 'month', 'day']}
          value={value ? value : null}
          onChange={(date: DatePickerValue) => {
            handleChange(date);
          }}
          shouldDisableDate={shouldDisableDate}
          enableAccessibleFieldDOMStructure={false}
          {...props}
          slotProps={{
            textField: {
              inputProps: {
                'aria-label': ariaLabel,
              },
            },
          }}
        />
      ) : (
        <DesktopDatePicker
          aria-label={ariaLabel}
          onAccept={onAccept}
          onClose={onClose}
          disabled={disabled}
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          openTo={openTo ? openTo : 'day'}
          views={views ? views : ['year', 'month', 'day']}
          value={value ? value : null}
          onChange={(date: DatePickerValue) => {
            handleChange(date);
          }}
          shouldDisableDate={shouldDisableDate}
          enableAccessibleFieldDOMStructure={false}
          {...props}
          slotProps={{
            textField: {
              inputProps: {
                'aria-label': ariaLabel,
              },
            },
          }}
        />
      )}
    </LocalizationProvider>
  ) as React.ReactElement;
};

export default DatePicker;
export { DatePicker };
